import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'month',
    standalone: false
})
export class MonthPipe implements PipeTransform {

  private static _monthNames: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  private static _monthNamesShort: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  transform(monthNumber: number, short: boolean = false): string {
    return short ? MonthPipe._monthNamesShort[monthNumber-1] : MonthPipe._monthNames[monthNumber-1];
  }

}
